
import React from 'react'
import PropTypes from 'prop-types'

function Skeleton({
  isLoading,
  height = '100%',
  width = '100%',
  className = '',
  style,
  ...rest
}) {
  if (!isLoading) return null

  return (
    <span
      aria-hidden="true"
      className={`skel__placeholder  ${className}`}
      style={{ height, width, ...style }}
      {...rest}
    />
  )
}

Skeleton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Skeleton
